import { render, staticRenderFns } from "./health-code.vue?vue&type=template&id=0c6998a4&scoped=true"
import script from "./health-code.vue?vue&type=script&lang=js"
export * from "./health-code.vue?vue&type=script&lang=js"
import style0 from "./health-code.vue?vue&type=style&index=0&id=0c6998a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6998a4",
  null
  
)

export default component.exports